
import { toast } from "react-toastify";
import { privateAxios } from "../../../config/apiConfig";
import {
  GET_EMPLOYEE_PROFILE_FAILURE,
  GET_EMPLOYEE_PROFILE_SUCCESS,
  GET_EMPLOYEE_PROFILE_REQUEST,
  UPDATE_EMPLOYEE_PROFILE_REQUEST,
  UPDATE_EMPLOYEE_PROFILE_FAILURE,
  UPDATE_EMPLOYEE_PROFILE_SUCCESS
} from "./ActionType";

export const getEmployeeProfile = () => async (dispatch) => {
  dispatch({ type: GET_EMPLOYEE_PROFILE_REQUEST });
  try {
    const { data } = await privateAxios.get(`employee/employee/profile`);
    dispatch({ type: GET_EMPLOYEE_PROFILE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_EMPLOYEE_PROFILE_FAILURE,
      payload: error.message
    });
  }
}

export const updateProfile = (profileId, profileData, setOpenProfile) => async (dispatch) => {
  dispatch({ type: UPDATE_EMPLOYEE_PROFILE_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `employee/profile/${profileId}`,
      profileData
    );
    if (data.status === "SUCCESS") {
      dispatch(getEmployeeProfile());
      dispatch({ type: UPDATE_EMPLOYEE_PROFILE_SUCCESS, payload: data });
      toast.success("Profile Updated !!");
      setOpenProfile(false)
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_EMPLOYEE_PROFILE_FAILURE, payload: error.message });
  }
};
